import { LazyQueryHookOptions } from "@apollo/client"
import {
  SellableItemStockDetailQuery,
  SellableItemStockDetailQueryVariables,
  SellableItemStockFilterInput,
  useRelatedStocksLazyQuery,
  useSellableItemsListLazyQuery,
  useSellableItemsStockListLazyQuery,
  useSellableItemsSuggestQuery,
  useSellableItemStockDetailLazyQuery,
} from "generated/graphql"
import { useSearchFilter } from "hooks/searchFilterHooks"
import { useEffect } from "react"
import { useCurrentDc } from "store/auth.redux"
import { useFilter } from "store/search-filter/search-filter.reducer"

export const useSellableItemList = () => {
  const [filter] = useFilter("sellable-items")
  const [{ search, page }] = useSearchFilter()
  const [getData, response] = useSellableItemsListLazyQuery()
  useEffect(() => {
    getData({
      variables: {
        query: search,
        first: 13,
        skip: page * 13,
        filter: {
          department: filter?.department?.id,
        },
      },
    })
  }, [search, getData, page, filter])
  return response
}

export const useSellableItemStockList = (
  filter?: SellableItemStockFilterInput | null
) => {
  const filterString = JSON.stringify(filter)
  const [{ search, page }] = useSearchFilter()
  const [getStocks, response] = useSellableItemsStockListLazyQuery()
  useEffect(() => {
    getStocks({
      variables: {
        query: search,
        first: 15,
        skip: page * 15,
        filter: JSON.parse(filterString),
      },
    })
  }, [search, getStocks, page, filterString])
  return response
}

export const useSellableItemStockDetail = (
  sellableItemId: string,
  options?: LazyQueryHookOptions<
    SellableItemStockDetailQuery,
    SellableItemStockDetailQueryVariables
  >
) => {
  const [dc] = useCurrentDc()
  const [getStockDetail, response] =
    useSellableItemStockDetailLazyQuery(options)

  useEffect(() => {
    if (sellableItemId) {
      getStockDetail({
        variables: {
          filter: {
            sellableItem: sellableItemId,
            distributionCentres: dc?.id ? [dc?.id] : undefined,
          },
        },
      })
    }
  }, [dc, getStockDetail, sellableItemId])
  return response
}

export const useSellableItemsSuggest = (params?: any) => {
  const [dc] = useCurrentDc()
  return useSellableItemsSuggestQuery({
    variables: {
      first: params?.id ? 1 : 4,
      query: params?.search,
      distributionCentreId: dc?.id,
    },
  })
}

export const useRelatedStock = (sellableItemId: string) => {
  const [getData, response] = useRelatedStocksLazyQuery()

  useEffect(() => {
    if (sellableItemId && parseInt(sellableItemId)) {
      getData({ variables: { sellableItem: sellableItemId } })
    }
  }, [getData, sellableItemId])

  return response
}
